import { Settings2 } from 'lucide-react'

/** Exibida quando as variáveis VITE_* são inválidas (em vez de cair em defaults silenciosos). */
export function ConfigErrorScreen({ errors }: { errors: string[] }) {
  return (
    <div className="flex min-h-full items-center justify-center bg-background p-6">
      <div
        role="alert"
        className="w-full max-w-lg rounded-xl border border-amber-200/70 bg-amber-50/60 p-6 dark:border-amber-900/50 dark:bg-amber-950/20"
      >
        <div className="flex items-center gap-3">
          <Settings2 className="h-5 w-5 text-amber-700 dark:text-amber-400" aria-hidden />
          <h1 className="text-base font-semibold">Configuração inválida</h1>
        </div>
        <p className="mt-2 text-sm text-muted-foreground">
          O Woctools não pode iniciar com as variáveis de ambiente atuais. Corrija o arquivo .env
          (veja .env.example) e gere o build novamente.
        </p>
        <ul className="mt-3 space-y-1 rounded-lg bg-background/70 p-3 font-mono text-xs text-muted-foreground">
          {errors.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}
